import { createSelector } from '@ngrx/store';

import { AppState } from '@state/app.state';

export const selectSearchKeyword = createSelector(
  (state: AppState) => state.searchKeyword,
  (searchKeyword: string) => searchKeyword
);
